var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 70,
    viewBox: "0 0 55 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard_icon 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.726 35.2182C36.726 35.6617 36.2825 36.1052 35.8389 36.1052H25.9035C25.4599 36.1052 25.0164 35.6617 25.0164 35.2182C25.0164 34.7746 25.4599 34.3311 25.9035 34.3311H35.8389C36.2825 34.3311 36.726 34.7746 36.726 35.2182Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.718 21.3788C29.718 21.8223 29.2744 22.2659 28.8309 22.2659H25.9035C25.4599 22.2659 25.0164 21.8223 25.0164 21.3788C25.0164 20.9352 25.4599 20.4917 25.9035 20.4917H28.8309C29.2744 20.4917 29.718 20.9352 29.718 21.3788Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.4276 25.2821C41.4276 25.7257 40.9841 26.1692 40.5405 26.1692H25.9035C25.4599 26.1692 25.0164 25.7257 25.0164 25.2821C25.0164 24.8386 25.4599 24.395 25.9035 24.395H40.5405C40.9841 24.395 41.4276 24.8386 41.4276 25.2821Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.8228 19.3384H14.1938C13.4841 19.3384 13.0405 19.7819 13.0405 20.4916V28.1206C13.0405 28.6529 13.7502 29.2739 14.1938 29.2739H21.8228C22.5325 29.2739 22.976 28.8303 22.976 28.1206V20.4916C22.976 19.7819 22.5325 19.3384 21.8228 19.3384ZM21.2018 27.4997H15.0808V21.3787H21.2018V27.4997Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.8228 32.2017H14.1938C13.4841 32.2017 13.0405 32.6452 13.0405 33.3549V40.9839C13.0405 41.6936 13.7502 42.1371 14.1938 42.1371H21.8228C22.5325 42.1371 22.976 41.6936 22.976 40.9839V33.3549C22.976 32.6452 22.5325 32.2017 21.8228 32.2017ZM21.2018 40.363H15.0808V34.242H21.2018V40.363Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.8228 44.8867H14.1938C13.4841 44.8867 13.0405 45.3303 13.0405 46.0399V53.669C13.0405 54.3787 13.7502 54.8222 14.1938 54.8222H21.8228C22.5325 54.8222 22.976 54.3787 22.976 53.669V46.0399C22.976 45.3303 22.5325 44.8867 21.8228 44.8867ZM21.2018 53.048H15.0808V46.927H21.2018V53.048Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M25.0164 21.3788C25.0164 20.9352 25.4599 20.4917 25.9035 20.4917H28.8309C29.2744 20.4917 29.718 20.9352 29.718 21.3788C29.718 21.8223 29.2744 22.2659 28.8309 22.2659H25.9035C25.4599 22.2659 25.0164 21.8223 25.0164 21.3788Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25.0164 48.0809C25.0164 47.6374 25.4599 47.1938 25.9035 47.1938H29.718C30.1615 47.1938 30.6051 47.6374 30.6051 48.0809C30.6051 48.5245 30.1615 48.968 29.718 48.968H25.9035C25.4599 48.968 25.0164 48.4358 25.0164 48.0809Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M25.0164 35.2182C25.0164 34.7746 25.4599 34.3311 25.9035 34.3311H35.8389C36.2825 34.3311 36.726 34.7746 36.726 35.2182C36.726 35.6617 36.2825 36.1052 35.8389 36.1052H25.9035C25.4599 36.1052 25.0164 35.6617 25.0164 35.2182Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M41.4276 51.8954C41.4276 52.3389 40.9841 52.7825 40.5405 52.7825H25.9035C25.4599 52.7825 25.0164 52.3389 25.0164 51.8954C25.0164 51.4518 25.4599 51.0083 25.9035 51.0083H40.5405C40.9841 51.0083 41.4276 51.4518 41.4276 51.8954Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M41.4276 39.2099C41.4276 39.6534 40.9841 40.0969 40.5405 40.0969H25.9035C25.4599 40.0969 25.0164 39.6534 25.0164 39.2099C25.0164 38.7663 25.4599 38.3228 25.9035 38.3228H40.5405C40.9841 38.3228 41.4276 38.7663 41.4276 39.2099Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M25.9035 24.395H40.5405C40.9841 24.395 41.4276 24.8386 41.4276 25.2821C41.4276 25.7257 40.9841 26.1692 40.5405 26.1692H25.9035C25.4599 26.1692 25.0164 25.7257 25.0164 25.2821C25.0164 24.8386 25.4599 24.395 25.9035 24.395Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M47.6374 7.62886H39.7422C39.7422 7.0966 39.5648 6.65305 39.21 6.29821C38.8551 6.03208 38.4116 5.85467 37.968 5.85467H33.0003C33.0003 5.05628 32.6454 4.3466 32.1132 3.81434C31.5809 3.28209 30.8713 2.92725 30.0729 2.92725H26.2583C24.6616 2.92725 23.3309 4.25789 23.3309 5.85467H18.3632C17.0325 5.58854 16.3229 6.56434 16.3229 7.62886H8.16157C5.41158 7.62886 3.45996 9.8466 3.45996 12.5966V60.8547C3.45996 63.6047 5.6777 65.8224 8.4277 65.8224H47.9035C50.6535 65.8224 52.8712 63.6047 52.8712 60.8547V12.5966C52.339 9.93531 50.2987 7.62886 47.6374 7.62886ZM18.2745 7.62886H37.8793V10.5563C37.8793 12.1531 36.5487 13.4837 34.9519 13.4837H21.2019C19.6051 13.4837 18.2745 12.1531 18.2745 10.5563V7.62886ZM46.3954 59.7014H9.13738V13.4837H17.1213C18.0083 14.6369 19.339 15.524 20.9358 15.524H34.6858C36.2825 15.524 37.6132 14.8143 38.5003 13.4837H46.3954V59.7014Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M21.8228 19.3384H14.1938C13.4841 19.3384 13.0405 19.7819 13.0405 20.4916V28.1206C13.0405 28.6529 13.7502 29.2739 14.1938 29.2739H21.8228C22.5325 29.2739 22.976 28.8303 22.976 28.1206V20.4916C22.976 19.7819 22.5325 19.3384 21.8228 19.3384ZM21.2018 27.4997H15.0808V21.3787H21.2018V27.4997Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M21.8228 32.2017H14.1938C13.4841 32.2017 13.0405 32.6452 13.0405 33.3549V40.9839C13.0405 41.6936 13.7502 42.1371 14.1938 42.1371H21.8228C22.5325 42.1371 22.976 41.6936 22.976 40.9839V33.3549C22.976 32.6452 22.5325 32.2017 21.8228 32.2017ZM21.2018 40.363H15.0808V34.242H21.2018V40.363Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M21.8228 44.8867H14.1938C13.4841 44.8867 13.0405 45.3303 13.0405 46.0399V53.669C13.0405 54.3787 13.7502 54.8222 14.1938 54.8222H21.8228C22.5325 54.8222 22.976 54.3787 22.976 53.669V46.0399C22.976 45.3303 22.5325 44.8867 21.8228 44.8867ZM21.2018 53.048H15.0808V46.927H21.2018V53.048Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M25.0164 21.3788C25.0164 20.9352 25.4599 20.4917 25.9035 20.4917H28.8309C29.2744 20.4917 29.718 20.9352 29.718 21.3788C29.718 21.8223 29.2744 22.2659 28.8309 22.2659H25.9035C25.4599 22.2659 25.0164 21.8223 25.0164 21.3788Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M25.0164 48.0809C25.0164 47.6374 25.4599 47.1938 25.9035 47.1938H29.718C30.1615 47.1938 30.6051 47.6374 30.6051 48.0809C30.6051 48.5245 30.1615 48.968 29.718 48.968H25.9035C25.4599 48.968 25.0164 48.4358 25.0164 48.0809Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M25.0164 35.2182C25.0164 34.7746 25.4599 34.3311 25.9035 34.3311H35.8389C36.2825 34.3311 36.726 34.7746 36.726 35.2182C36.726 35.6617 36.2825 36.1052 35.8389 36.1052H25.9035C25.4599 36.1052 25.0164 35.6617 25.0164 35.2182Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M41.4276 51.8954C41.4276 52.3389 40.9841 52.7825 40.5405 52.7825H25.9035C25.4599 52.7825 25.0164 52.3389 25.0164 51.8954C25.0164 51.4518 25.4599 51.0083 25.9035 51.0083H40.5405C40.9841 51.0083 41.4276 51.4518 41.4276 51.8954Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M41.4276 39.2099C41.4276 39.6534 40.9841 40.0969 40.5405 40.0969H25.9035C25.4599 40.0969 25.0164 39.6534 25.0164 39.2099C25.0164 38.7663 25.4599 38.3228 25.9035 38.3228H40.5405C40.9841 38.3228 41.4276 38.7663 41.4276 39.2099Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M25.0164 25.2821C25.0164 24.8386 25.4599 24.395 25.9035 24.395H40.5405C40.9841 24.395 41.4276 24.8386 41.4276 25.2821C41.4276 25.7257 40.9841 26.1692 40.5405 26.1692H25.9035C25.4599 26.1692 25.0164 25.7257 25.0164 25.2821Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M21.8228 32.2017H14.1938C13.4841 32.2017 13.0405 32.6452 13.0405 33.3549V40.9839C13.0405 41.6936 13.7502 42.1371 14.1938 42.1371H21.8228C22.5325 42.1371 22.976 41.6936 22.976 40.9839V33.3549C22.976 32.6452 22.5325 32.2017 21.8228 32.2017ZM21.2018 40.363H15.0808V34.242H21.2018V40.363Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M21.8228 19.3384H14.1938C13.4841 19.3384 13.0405 19.7819 13.0405 20.4916V28.1206C13.0405 28.6529 13.7502 29.2739 14.1938 29.2739H21.8228C22.5325 29.2739 22.976 28.8303 22.976 28.1206V20.4916C22.976 19.7819 22.5325 19.3384 21.8228 19.3384ZM21.2018 27.4997H15.0808V21.3787H21.2018V27.4997Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M41.4276 39.2099C41.4276 39.6534 40.9841 40.0969 40.5405 40.0969H25.9035C25.4599 40.0969 25.0164 39.6534 25.0164 39.2099C25.0164 38.7663 25.4599 38.3228 25.9035 38.3228H40.5405C40.9841 38.3228 41.4276 38.7663 41.4276 39.2099Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M21.8228 44.8867H14.1938C13.4841 44.8867 13.0405 45.3303 13.0405 46.0399V53.669C13.0405 54.3787 13.7502 54.8222 14.1938 54.8222H21.8228C22.5325 54.8222 22.976 54.3787 22.976 53.669V46.0399C22.976 45.3303 22.5325 44.8867 21.8228 44.8867ZM21.2018 53.048H15.0808V46.927H21.2018V53.048Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M41.4276 51.8954C41.4276 52.3389 40.9841 52.7825 40.5405 52.7825H25.9035C25.4599 52.7825 25.0164 52.3389 25.0164 51.8954C25.0164 51.4518 25.4599 51.0083 25.9035 51.0083H40.5405C40.9841 51.0083 41.4276 51.4518 41.4276 51.8954Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M30.6051 48.0809C30.6051 48.5245 30.1615 48.968 29.718 48.968H25.9035C25.4599 48.968 25.0164 48.4358 25.0164 48.0809C25.0164 47.6374 25.4599 47.1938 25.9035 47.1938H29.718C30.1615 47.1938 30.6051 47.6374 30.6051 48.0809Z",
    fill: "#007FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 7655",
    d: "M5 13C5 11.3431 6.34315 10 8 10H12V64H8C6.34315 64 5 62.6569 5 61V13Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 7656",
    d: "M8 10H13C15.7614 10 18 12.2386 18 15H8V10Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 7657",
    d: "M38 15C38 12.2386 40.2386 10 43 10H45V15H38Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 7658",
    d: "M45 10H48C49.6569 10 51 11.3431 51 13V60C51 61.6569 49.6569 63 48 63H45V10Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 7659",
    d: "M11 58H51V61C51 62.6569 49.6569 64 48 64H11V58Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardIcon);
export default __webpack_public_path__ + "static/media/clipboard_icon.0da617214150388e8bfb8b2533c948f8.svg";
export { ForwardRef as ReactComponent };